import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCornerRadius: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCornerRadius"><Path d="M20.25 3.75H16.55C12.0696 3.75 9.82937 3.75 8.11808 4.62195C6.61278 5.38893 5.38893 6.61278 4.62195 8.11808C3.75 9.82937 3.75 12.0696 3.75 16.55V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCornerRadius;
